/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */

// Packages
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Button, Modal, Form, Table, FormControl } from 'react-bootstrap';

// Components
import FormUI from 'components/UI/FormUI';
import TableUI from 'components/UI/TableUI';
import ConditionalRender from 'components/ConditionalRender';
import {
  getItems,
  selectDepartmentInventory,
  itemRequestForRepairSubmit,
  resetItemRequestForRepairSubmitLogs,
} from 'reducers/departmentInventoryReducer';

// import assets below
import './style.scss';
import { ReactComponent as CirclePlus } from 'assets/svg/circle-plus.svg';
import { ReactComponent as CircleXMark } from 'assets/svg/circle-xmark.svg';
import { ReactComponent as CircleMinus } from 'assets/svg/circle-minus.svg';
import { ReactComponent as FileUploadSVG } from 'assets/svg/file-upload.svg';
import { toast } from 'react-toastify';

const initialState = {
  id: '',
  status: '',
  item_count: '',
  image: '',
  requested_by: '',
  description: '',
};

// main component
const RequestToRepair = ({
  showModal,
  departmentID,
  setShowModal,
  refreshData,
  setRefreshData,
  getInventoryMaintenanceRepair,
}) => {
  const dispatch = useDispatch();
  const itemsInventory = useSelector(selectDepartmentInventory);
  const { nonMedicineItemData, nonMedicineItemLogs, itemRequestForRepairSubmitLogs } =
    itemsInventory;

  const [items, setItems] = useState([]);
  const [formData, setFormData] = useState(initialState);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleChange = (key) => (e) => {
    setFormData((prev) => {
      return {
        ...prev,
        [key]: e.target.value,
      };
    });
  };

  const handleSave = () => {
    const newFormData = new FormData();

    newFormData.append('item_id', formData?.id);
    newFormData.append('image', formData?.image);
    newFormData.append('status', formData?.status);
    newFormData.append('department_id', departmentID);
    newFormData.append('item_count', formData?.item_count);
    newFormData.append('requested_by', formData?.requested_by);
    newFormData.append('description', formData?.description);

    dispatch(itemRequestForRepairSubmit(newFormData));
  };

  useEffect(() => {
    const { isSuccess } = nonMedicineItemLogs;

    if (isSuccess) {
      setItems(nonMedicineItemData);
    }
  }, [nonMedicineItemLogs]);

  useEffect(() => {
    if (formData?.id) {
      const data = items.filter((data) => data?.id === formData?.id);

      setSelectedItem(data[0]);
    }
  }, [formData]);

  useEffect(() => {
    const { isSuccess, isFailed } = itemRequestForRepairSubmitLogs;

    if (isSuccess) {
      setSelectedItem(null);
      setFormData(initialState);
      getInventoryMaintenanceRepair();
      toast.success('Successfully requested item to repair.');
      dispatch(resetItemRequestForRepairSubmitLogs());

      setShowModal((prevState) => {
        return {
          ...prevState,
          showRequestRepair: false,
        };
      });
    }

    if (isFailed) {
      toast.error('Something went wrong.aaa');
      dispatch(resetItemRequestForRepairSubmitLogs());
    }
  }, [itemRequestForRepairSubmitLogs]);

  return (
    <Modal
      size='lg'
      show={showModal.showRequestRepair}
      onHide={() =>
        setShowModal((prevState) => {
          return {
            ...prevState,
            showRequestRepair: false,
          };
        })
      }
      aria-labelledby='ITEM FOR REQUEST TO REPAIR'
      className='request-for-repair-modal'
    >
      <Modal.Body>
        <div className='request-for-repair-request'>
          <div className='d-flex header'>
            <p>ITEM FOR REQUEST TO REPAIR</p>

            <CircleXMark
              style={{ width: '2em', cursor: 'pointer' }}
              onClick={() => {
                setShowModal((prevState) => {
                  return { ...prevState, showRequestRepair: false };
                });
              }}
            />
          </div>
        </div>

        <FormUI>
          <Form className='adjustment-form'>
            <Row>
              <Col sm={6}>
                <Form.Group className='mb-2'>
                  <Form.Label>Select Item</Form.Label>
                  <Form.Select value={formData?.id} onChange={handleChange('id')}>
                    <option value='' hidden>
                      Select Item
                    </option>

                    {items &&
                      items.length > 0 &&
                      items.map((data) => {
                        return (
                          <option key={data?.id} value={data?.id}>
                            {data?.attributes?.name}
                          </option>
                        );
                      })}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Group className='mb-2'>
                  <Form.Label>Equipment Name</Form.Label>
                  <FormControl
                    readOnly
                    type='text'
                    className='bg-white'
                    placeholder='Equipment Name Here'
                    value={selectedItem?.attributes?.name || ''}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Group className='mb-2'>
                  <Form.Label>Description</Form.Label>
                  <FormControl
                    rows='5'
                    as='textarea'
                    className='bg-white'
                    value={formData?.description}
                    onChange={handleChange('description')}
                    placeholder='Enter Detailed Description Here'
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col sm={3}>
                <Form.Group className='mb-2'>
                  <Form.Label>Item Status</Form.Label>
                  <Form.Select value={formData?.status} onChange={handleChange('status')}>
                    <option value='' hidden>
                      Select Status
                    </option>
                    <option value='repair '>For Repair</option>
                    <option value='condemnation'>For Condemnation</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col sm={3}>
                <Form.Group className='mb-2'>
                  <Form.Label>Item Count</Form.Label>
                  <FormControl
                    type='number'
                    className='bg-white'
                    value={formData?.item_count}
                    onChange={handleChange('item_count')}
                    onKeyDown={(evt) =>
                      ['e', 'E', '+', '-'].includes(evt.key) && evt.preventDefault()
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Group className='upload-image mb-4 mt-4'>
                  <p>
                    Upload Image <span>PNG and JPG files are allowed</span>
                  </p>

                  <div className='cont'>
                    <ConditionalRender
                      condition={formData?.image === ''}
                      renderIf={<FileUploadSVG />}
                    />
                    <ConditionalRender
                      condition={formData?.image !== ''}
                      renderIf={<span>{formData?.image?.name}</span>}
                    />

                    <Form.Label htmlFor='upload-image'>
                      {/* Drag and drop or <b>browse</b> your file */}
                      Click to <b>browse</b> your file
                    </Form.Label>

                    <FormControl
                      type='file'
                      id='upload-image'
                      accept='image/png, image/jpeg'
                      onChange={(e) => {
                        // eslint-disable-next-line prefer-const
                        let docuArr = [];

                        Array.from(e.target.files).forEach((file) => {
                          docuArr.push(file);
                        });

                        if (e?.target?.files[0]) {
                          setFormData((prevState) => {
                            return {
                              ...prevState,
                              image: e.target.files[0],
                            };
                          });
                        }
                      }}
                    />
                  </div>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col sm={3}>
                <Form.Group className='mb-2'>
                  <Form.Label>Requested By</Form.Label>
                  <FormControl
                    type='text'
                    className='bg-white'
                    value={formData?.requested_by}
                    onChange={handleChange('requested_by')}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className='mt-4'>
              <Col>
                <div className='buttons-cont'>
                  <Button onClick={handleSave} className='save'>
                    SAVE
                  </Button>
                  <Button
                    onClick={() => {
                      setShowModal((prevState) => {
                        return { ...prevState, showRequestRepair: false };
                      });
                    }}
                    className='cancel'
                  >
                    CANCEL
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </FormUI>
      </Modal.Body>
    </Modal>
  );
};

RequestToRepair.defaultProps = {
  showModal: {},
  setShowModal: () => {},
};

RequestToRepair.propTypes = {
  showModal: PropTypes.object,
  setShowModal: PropTypes.func,
};

export default RequestToRepair;
